import { render } from "./StudentHistoryImport.vue?vue&type=template&id=3fa5b859&scoped=true"
import script from "./StudentHistoryImport.vue?vue&type=script&lang=js"
export * from "./StudentHistoryImport.vue?vue&type=script&lang=js"

import "./StudentHistoryImport.vue?vue&type=style&index=0&id=3fa5b859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa5b859"]])

export default __exports__